module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Upload-ab2be4d041425755117f1b9cecc35a3c.svg";